export default __webpack_public_path__ + "1ed9aa759c0d4aa9c6125e868ce012b7.png";